/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Item_Stats_Meanprice1Inputs */

const he_item_stats_meanprice1 = /** @type {(inputs: Item_Stats_Meanprice1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`המחיר הממוצע`)
};

const en_item_stats_meanprice1 = /** @type {(inputs: Item_Stats_Meanprice1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Average price`)
};

/**
* | output |
* | --- |
* | "Average price" |
*
* @param {Item_Stats_Meanprice1Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const item_stats_meanprice1 = /** @type {((inputs?: Item_Stats_Meanprice1Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Item_Stats_Meanprice1Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_item_stats_meanprice1(inputs)
	return en_item_stats_meanprice1(inputs)
});
export { item_stats_meanprice1 as "item_stats_meanPrice" }